<template>
  <div class="container">
    <add-group
      v-if="dialog_add_group"
      :dialog-visible="dialog_add_group"
      @close="dialog_add_group = !dialog_add_group"
    />

    <edit-group
      v-if="dialog_edit_group"
      :dialog-visible="dialog_edit_group"
      :group="group"
      @close="dialog_edit_group = !dialog_edit_group"
    />

    <!--  Button: add group  -->
    <el-row :gutter="24">
      <el-col :span="16">
        <div class="title">
          <p style="float: left">
            Пользовательские группы
            <img src="@/assets/img/ask.svg" />
          </p>
          <span style="float: right" @click="dialog_add_group = true">
            Добавить группу
          </span>
        </div>
      </el-col>
    </el-row>

    <group-list @openDialogListContragent="openDialogListContragent" />
  </div>
</template>

<script>
import AddGroup from './modals/AddGroup'
import EditGroup from './modals/EditGroup'
import GroupList from './GroupList'

export default {
  name: 'GroupEdit',
  components: {
    AddGroup,
    GroupList,
    EditGroup,
  },
  data() {
    return {
      group: {
        title: '',
        info: '',
        id: '',
      },
      dialog_add_group: false,
      dialog_edit_group: false,
    }
  },
  methods: {
    async openDialogListContragent(group) {
      this.group = {
        id: group.id,
        name: group.name,
      }
      this.dialog_edit_group = true
    },
  },
}
</script>

<style scoped>
.title p {
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
}

.title p img {
  margin-left: 8px;
}

.title {
  font-size: 20px;
  line-height: 24px;
  padding: 0 16px;
}

.title span {
  padding-top: 10px;
  font-size: 18px;
  line-height: 21px;
  color: #3498db;
  cursor: pointer;
  text-decoration: none;
}

.title span:hover {
  text-decoration: underline;
}

.auto_list-item {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 16px rgba(153, 155, 168, 0.12);
  padding: 20px;
  margin: 16px 0 13px 0;
}

.auto_list-item p {
  font-size: 20px;
  line-height: 24px;
  margin: 0;
}

.auto_list-actions-scores {
  display: flex;
  justify-content: space-around;
}

.center {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.center p {
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  color: #3498db;
  border-radius: 5px;
}

.center p:hover {
  text-decoration: underline;
  cursor: pointer;
}

.center img {
  margin-right: 24px;
}

.center span {
  font-weight: bold;
}
.transfer {
  width: 100%;
}
</style>
